import React from 'react';
import { Row, Col, FormGroup, Label, Input, FormFeedback } from 'reactstrap';

const CardFields = ({
                        values,
                        errors,
                        touched,
                        onOwnerChange,
                        onNumberChange,
                        onMonthChange,
                        onYearChange,
                        onCVVChange,
                        onCVVFocus,
                        onCVVBlur,
                        years,
                        helper
                    }) => (
    <>
        <FormGroup className="mb-3">
            <Label>Kart Üzerindeki İsim *</Label>
            <Input
                type="text"
                inputMode="text"
                autoComplete="cc-name"
                placeholder="Kart üzerindeki isim"
                value={values.cc_owner}
                onChange={onOwnerChange}
                onBeforeInput={(e) => {
                    const data = e.nativeEvent?.data;
                    if (data && /[^a-zA-ZğüşöçıİĞÜŞÖÇ\s]/.test(data)) {
                        e.preventDefault();
                    }
                }}
                onPaste={(e) => {
                    const text = e.clipboardData?.getData('text') || '';
                    if (/[^a-zA-ZğüşöçıİĞÜŞÖÇ\s]/.test(text)) {
                        e.preventDefault(); // uygunsuz metni yapıştırmayı engelle
                    }
                }}
                invalid={touched.cc_owner && !!errors.cc_owner}
            />
            {touched.cc_owner && errors.cc_owner && <FormFeedback>{errors.cc_owner}</FormFeedback>}
        </FormGroup>

        <FormGroup className="mb-3">
            <Label>Kart Numarası *</Label>
            <Input
                type="text"
                placeholder="XXXX XXXX XXXX XXXX"
                maxLength="19"
                value={values.card_number}
                onChange={onNumberChange}
                invalid={touched.card_number && !!errors.card_number}
            />
            {touched.card_number && errors.card_number && <FormFeedback>{errors.card_number}</FormFeedback>}
            {helper}
        </FormGroup>

        <Row>
            <Col xs={4}>
                <FormGroup className="mb-3">
                    <Label>Ay *</Label>
                    <Input type="select" value={values.expiry_month} onChange={onMonthChange} invalid={touched.expiry_month && !!errors.expiry_month}>
                        <option value="">Ay</option>
                        {Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, '0')).map(m => <option key={m} value={m}>{m}</option>)}
                    </Input>
                    {touched.expiry_month && errors.expiry_month && <FormFeedback>{errors.expiry_month}</FormFeedback>}
                </FormGroup>
            </Col>
            <Col xs={4}>
                <FormGroup className="mb-3">
                    <Label>Yıl *</Label>
                    <Input type="select" value={values.expiry_year} onChange={onYearChange} invalid={touched.expiry_year && !!errors.expiry_year}>
                        <option value="">Yıl</option>
                        {years.map(y => <option key={y} value={y.toString().slice(-2)}>{y.toString().slice(-2)}</option>)}
                    </Input>
                    {touched.expiry_year && errors.expiry_year && <FormFeedback>{errors.expiry_year}</FormFeedback>}
                </FormGroup>
            </Col>
            <Col xs={4}>
                <FormGroup className="mb-3">
                    <Label>CVV *</Label>
                    <Input
                        type="text"
                        placeholder="CVV"
                        maxLength="4"
                        value={values.cvv}
                        onFocus={onCVVFocus}
                        onBlur={onCVVBlur}
                        onChange={onCVVChange}
                        invalid={touched.cvv && !!errors.cvv}
                    />
                    {touched.cvv && errors.cvv && <FormFeedback>{errors.cvv}</FormFeedback>}
                </FormGroup>
            </Col>
        </Row>
    </>
);

export default CardFields;